import { natService } from '@/services/NatService';
import { websocketService } from '@/services/WebsocketService';

const state = () => ({
  nats: [],
  isFetched: false,
});

const mutations = {
  setNats(state: any, nats: any) {
    let set = new Set();
    state.nats = [...nats];
    state.isFetched = true;
  },
  appendNats(state: any, nats: any) {
    let set = new Set();
    state.nats = [...nats, ...state.nats].filter((item: any) => {
      if (!set.has(item.id)) {
        set.add(item.id);
        return true;
      }
      return false;
    }, set);
    state.isFetched = true;
  },
  removeNats(state: any, natIds: any) {
    let set = new Set();
    state.nats = state.nats.filter((item: any) => {
      return !natIds.filter((id: any) => item.id === id).length;
    }, set);
  },
};

const actions = {
  getByAddressId({ commit, state, rootState }: any, publicIpAddressId: number) {
    return natService
      .getNats(rootState.currentWorkspace.id, rootState.currentWorkspace.currentRegionId, publicIpAddressId)
      .then((data: any) => {
        commit('appendNats', data.nats);
      });
  },
  getAllNats({ commit, state, rootState }: any, isForced: boolean = false) {
    return new Promise(resolve => {
      // console.log('state.isFetched', state.isFetched);
      if (state.isFetched && !isForced && websocketService.isConnected) {
        resolve(state.nats);
        return;
      }
      natService
        .getAllNats(rootState.currentWorkspace.id, rootState.currentWorkspace.currentRegionId)
        .then((data: any) => {
          commit('setNats', data.nats);
          resolve(data.nats);
        });
    });
  },
};

const getters = {
  getByPublicIpAddressId: (state: any, getters: any, rootState: any) => (id: number) => {
    return state.nats.filter((item: any) => item.public_ip_address && id === item.public_ip_address.id);
  },
  getByNicId: (state: any, getters: any, rootState: any) => (id: number) => {
    return state.nats.filter((item: any) => item.nic && id === item.nic.id);
  },
  getByVirtualMachineId: (state: any, getters: any, rootState: any) => (id: number) => {
    return state.nats.filter((item: any) => item.nic && id === item.nic.virtual_machine_id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
